import { render, staticRenderFns } from "./CmgStaticPage.vue?vue&type=template&id=7fef600f&scoped=true&lang=pug"
import script from "./cmg-static-page.ts?vue&type=script&lang=ts&external"
export * from "./cmg-static-page.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgStaticPage.vue?vue&type=style&index=0&id=7fef600f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fef600f",
  null
  
)

export default component.exports